import { Module, VuexModule, getModule, Mutation } from "vuex-module-decorators";
import store from "@/store/index";

export interface ICategoryModule {
  _categoryId: number | null;
}

@Module({ dynamic: true, store, name: "category", namespaced: true, preserveState: false })
class CategoryModule extends VuexModule implements ICategoryModule {
  public _categoryId: number | null = 0;

  @Mutation
  public changeCategoryId(categoryId: number | null) {
    this._categoryId = categoryId;
  }

  @Mutation
  public resetCategoryId(categoryId: number | null) {
    this._categoryId = categoryId;
  }

  public get categoryId() {
    return this._categoryId;
  }
}

export default getModule(CategoryModule);
